var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"404"}},[_c('base-img',{staticClass:"mx-auto",attrs:{"src":require('@/assets/not-found.png'),"contain":"","height":"550","width":"450"}}),_c('div',{staticClass:"text-center"},[_c('base-btn',{attrs:{"to":{ name: 'beranda' }}},[_vm._v(" Kembali Ke Beranda ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }